import styled from 'styled-components';
import { Form } from 'formik';
import FormikSelect from '../../../CommonComponents/FormikSelect';

export const StyledForm = styled(Form)`
  width: 650px;
  padding: 48px 48px 48px 68px;
  box-sizing: border-box;
  margin-right: 20px; // Prevents horizontal scrollbar on IE11 and Edge
`;

export const Label = styled.label`
  display: block;
  max-width: 275px;
  margin-bottom: 16px;
`;

export const LabelText = styled.div`
  font-weight: 400;
  color: #585454;
  margin-bottom: 8px;
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-top: 64px;

  > * {
    margin-left: 20px;
  }
`;

export const Select = styled(FormikSelect)`
  display: block;
  height: 35px;

  &.react-selectize {
    &::after {
      display: none;
    }
  }
`;
